import { createGlobalStyle } from 'styled-components';

export const TransactionFieldConfigStyles = createGlobalStyle`
  // add class name here
  &.preclearance,
  &.bankFile,
  &.numberOfAVArticle,
  &.licenseAndPermitsInformation,
  &.ucr,
  &.dateShippedOnBoard,
  &.quota,
  &.supplier,
  .dummy-hidden {
    display: none;
  }

  // when adding the class name, always include [class^="FieldFrame-module_fieldContainer"] to disable the actual input
  .dummy-disabled [class^="FieldFrame-module_fieldContainer"] {
    background-color: #FAFBFC !important;
    pointer-events: none;
    cursor: not-allowed;
  }
`;
